import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpandPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 19,
	height: 19,
	viewBox: "0 0 19 19",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0.5 9.5C0.5 4.53 4.53 0.5 9.5 0.5C14.47 0.5 18.5 4.53 18.5 9.5C18.5 14.47 14.47 18.5 9.5 18.5C4.53 18.5 0.5 14.47 0.5 9.5Z",
			fill: "#7EB781",
			fillOpacity: .5,
			stroke: "#3D3938",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.5 9.5H14.5",
			stroke: "#3D3938",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.505 4.50488L9.505 14.5049",
			stroke: "#3D3938",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgExpandPlus);
export default ForwardRef;
